/* eslint-disable camelcase */
import React from 'react';
import moment from 'moment';
import {
  colorAccessibleGreen,
  colorTelusPurple,
} from '@tds/core-colours/dist/index.cjs';
import {Text} from './css';
import {Box} from '../design/css';

const OrderComments = data => {
  if (!(data && data.length)) return null;

  return data.map (comment => {
    const {text, createdAt, user: {first_name, last_name}} = comment;
    return (
      text &&
      <Box>
        <Text
          bold
          color={colorTelusPurple}
        >{`${first_name.concat (' ', last_name)} : `}</Text>
        <Text fontWeight="500">{`${text} - `}</Text>
        <Text bold color={colorAccessibleGreen}>
          {moment (createdAt).format ('dddd, MMMM Do YYYY, h:mm:ss a')}
        </Text>

      </Box>
    );
  });
};

export default OrderComments;
